import React, { useEffect } from 'react';
import '../components/MySkills/MySkills.css';

import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Mailsent from './assets/Mailsent.svg';


function FormSubmission() {

    const navigate = useNavigate();

    useEffect(() => {
        const redirectTimeout = setTimeout(() => {
            navigate('/'); // Redirects to home page after 5 seconds
        }, 5000); // 5000ms = 5 seconds
    
        return () => clearTimeout(redirectTimeout); // Cleanup function
    }, [navigate]);
    


    return (

        <Container fluid className="formsentPage" style={{ overflowX: 'hidden', height:100+'dvh' }}>
           
          
                <center>
                    <img style={{ width: 20 + 'rem' }}
                        className="img-fluid "
                        src={Mailsent}
                        alt="SentImage"
                    />
                    <div style={{marginTop:-5+'rem'}}>
                        <h1 className="aboutHeadingxx" style={{ fontSize: 2.8 + 'rem', }} >Message Sent</h1>
                        <p style={{ lineHeight: 2 + 'rem' }} className="aboutHeadingxxParagraph">
                            Thank you, your message has been sent to Olayimmika
                        </p>
                    </div>
                </center>
           
        </Container>

    );
}

export default FormSubmission;
